import React from 'react';
import { ValidationError } from '../services/formValidation';

interface FormErrorProps {
  field: string;
  errors?: ValidationError[];
  value?: string;
  maxWords?: number;
}

const FormError: React.FC<FormErrorProps> = ({ field, errors = [], value = '', maxWords }) => {
  const fieldErrors = errors.filter(error => error.field === field);

  // Calculate word count for description fields
  const getWordCount = (text: string): number => {
    return text.trim().split(/\s+/).filter(word => word.length > 0).length;
  };

  const wordCount = getWordCount(value);
  const isDescriptionField = field === 'entry_info' || field === 'company_info' ||
                           field.startsWith('judging_specialfeature_');

  if (fieldErrors.length === 0 && !isDescriptionField) {
    return null;
  }

  return (
    <div className="error">
      {fieldErrors.map((error, index) => (
        <div key={index} className="error-message">
          {error.message}
        </div>
      ))}

      {/* Word count display for description fields */}
      {isDescriptionField && value.trim() && (
        <div className="word-count" style={{
          color: wordCount > (maxWords || 150) ? '#dc3545' : '#6c757d',
          fontSize: '11px',
          marginTop: '2px'
        }}>
          {wordCount} / {maxWords || 150} words
        </div>
      )}
    </div>
  );
};

export default FormError;